import React, {Component} from 'react'
import Btn from '../../Components/Btn/Btn'
import Input from '../../Components/Input/Input'
import Overlay from './Overlay'
import Select from 'react-select'
import { connect } from 'react-redux'
import {ActionCreators} from '../../Actions'
import {positions} from '../../Lists/lists'
import {restaurantEditChef} from '../../Services/Restaurant/restaurant'
import {validate} from '../../Components/Input/validate'
import {translate} from '../../Translations/translate'
import { withRouter } from 'react-router'

class RestaurantChefOverlay extends Component {
    constructor(props) {
        super(props)
        let value = this.props.data.value
        this.state = {
            id: this.props.data.id ? this.props.data.id : 0,
            person: value.person ? value.person : '',
            position: value.position ? value.position : '',
            errors: []
        }
    }
    render() {
        const { lang } = this.props.match.params
        return (
            <Overlay title={translate(lang, 'edit_chef')} className={this.props.className}>
                <div className="col-group form">
                    <div className="col-mb-12 col-6">
                        <Input
                            label={translate(lang, 'person')}
                            name="person"
                            error={this.state.errors}
                            value={this.state.person}
                            onChange={(v) => {
                                this.setState({person: v})
                            }}
                            />
                    </div>
                    <div className="col-mb-12 col-6">
                        <label htmlFor="type">{translate(lang, 'position')}</label>
                        <Select
                            placeholder=""
                            name="position"
                            value={this.state.position}
                            className={this.state.errors.indexOf('position') !== -1 ? 'error' : null}
                            onChange={(option) => { this.setState({ position: option ? option.value : -1 }) }}
                            options={positions[lang]}
                            />
                    </div>

                    <div className="col-mb-12 actions multiple">
                        {parseInt(this.state.id) !== 0 ? <div className="accessory">
                            <Btn text={translate(lang, 'delete').toUpperCase()} loading={this.state.loadingError} className="delete" callback={() => {
                                this.delete()
                            }} />
                        </div> : null}
                        <div className="main">
                            <Btn text={translate(lang, 'cancel').toUpperCase()} className="inverted" callback={() => {
                                this.props.showOverlay(null)
                            }} />
                            <Btn text={translate(lang, 'save').toUpperCase()} loading={this.state.loading} callback={() => {
                                this.save()
                            }} />
                        </div>
                    </div>
                </div>
            </Overlay>
        )
    }
    save() {
        const { lang } = this.props.match.params
        let items = [
            {field: 'person'},
            {field: 'position'},
        ];
        let errors = validate(items, this.state)
        this.setState({ errors: errors })
        if (errors.length === 0) {
            this.setState({ loading: true })
            //SAVE
            let data = {
                rid: this.props.data.rid,
                id: this.state.id,
                name: 'chef',
                order: 0,
                value: JSON.stringify({
                    person: this.state.person,
                    position: this.state.position,
                }),
                lang: lang
            }
            restaurantEditChef(data).then((res) => {
                this.setState({ loading: false })
                if (!res.data.success) {
                    this.props.showOverlay('error', {message: res.data.message})
                    return
                }
                let data = res.data.data
                this.props.setUser(data.user)
                this.props.showOverlay(null)
            }).catch((e) => {
                this.props.showOverlay('error', {message: e.message})
            })
        }
    }
    delete() {
        const { lang } = this.props.match.params
        this.setState({ loadingDelete: true })
        restaurantEditChef({rid: this.props.data.rid, id: this.state.id, action: 'delete', lang}).then((res) => {
            this.setState({ loadingDelete: false })
            if (!res.data.success) {
                this.props.showOverlay('error', {message: res.data.message})
                return
            }
            let data = res.data.data
            this.props.setUser(data.user)
            this.props.showOverlay(null)
        }).catch((e) => {
            this.props.showOverlay('error', {message: e.message})
        })
    }
};

const mapStateToProps = state => {
    return {
        deviceScreen: state.deviceScreen,        
    }
}
export default withRouter(connect(mapStateToProps, ActionCreators)(RestaurantChefOverlay))
